import { Component } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface ImageBlock extends ContentBlock {
    image: string;
    image_caption?: string;
    image_credit?: string;
    url?: string;
}

@Component({
    template: `
        <div class="image-container">
            <ng-container *ngIf="block.url">
                <a url="{{block.url}}">
                    <responsive-picture [src]="block.image"></responsive-picture>
                </a>
            </ng-container>
            <ng-container *ngIf="!block.url">
                <responsive-picture [src]="block.image"></responsive-picture>
            </ng-container>
            <caption>
                <span class="cms-content" *ngIf="block.image_caption" [innerHTML]="block.image_caption | markdownToHtml | trustHtml"></span>
                <span class="cms-content" *ngIf="block.image_credit" [innerHTML]="block.image_credit | markdownToHtml | trustHtml"></span>
            </caption>
        </div>
    `,
    styles: [`
        caption {
            display: block;
            color: #888;
            padding: 0.75em 0 1.25em 0;
            font-size: 0.8em;

            & ::ng-deep p {
                display: inline;
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<ImageBlock> {
}

@Component({
    template: `
        <tyt-image-asset
            [(url)]="block.image"
            [disabled]="locked"></tyt-image-asset>

        <mat-form-field class="caption">
            <mat-label>Caption</mat-label>
            <input name="image_caption" matInput type="text" [(ngModel)]="block.image_caption"
                [disabled]="locked" />
        </mat-form-field>
        <mat-form-field class="credit">
            <mat-label>Credit</mat-label>
            <input name="image_credit" matInput type="text" [(ngModel)]="block.image_credit"
                [disabled]="locked" />
        </mat-form-field>
        <tyt-url-field
            label="Link"
            [(value)]="block.url"
            [disabled]="locked"
            ></tyt-url-field>

    `,
    styles: [
        `
        mat-form-field {
            width: 100%;
        }
        `
    ]
})
export class EditorComponent extends ContentBlockEditorComponent<ImageBlock> {
}

export const IMAGE_BLOCK_TYPE: ContentBlockType<ImageBlock> = {
    id: 'image',
    label: 'Image',
    icon: 'image',
    template: {

    },
    preview: {
        image: '/assets/operation-hope/support-c2a-bg.png'
    },
    previewSettings: {
        horizontalAlign: 'center',
        verticalAlign: 'top'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
